import React from "react";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import "../components/layout/style.css";
import Layout from "../components/layout";
import { useTranslation } from "react-i18next";

function NotFound() {
  const { t } = useTranslation();
  return (
    <Layout>
      <ErrorOutlineIcon className="icon" />
      <Layout.Title>{t("generals.pageNotFound")}</Layout.Title>
    </Layout>
  );
}

export default NotFound;
